module.exports = __webpack_public_path__ + "assets/b52.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b52.png
// module id = 641
// module chunks = 0